import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var LeafIcon = function LeafIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "LeafIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.657 1.942c-3.093 0-5.29.685-6.721 1.927-1.45 1.257-1.999 2.983-2.004 4.796v.002c0 .638.003 1.943 1.062 3.3a11.4 11.4 0 0 0-.382 1.953.725.725 0 0 0 1.442.16q.077-.711.237-1.355H6c2.198 0 4.159-.583 5.609-2.034 1.443-1.444 2.275-3.642 2.448-6.65l.001-.04V2.666c0-.4-.324-.725-.725-.725zm-5.856 9.333H6c1.947 0 3.487-.512 4.583-1.61 1.101-1.1 1.862-2.897 2.025-5.686v-.587h-1.95c-2.908 0-4.706.647-5.772 1.572-1.048.91-1.5 2.184-1.504 3.704v.005c0 .388 0 .967.288 1.624q.18-.337.393-.658c.834-1.25 2.03-2.251 3.642-2.968a.725.725 0 0 1 .59 1.325c-1.388.616-2.359 1.448-3.025 2.448a6.5 6.5 0 0 0-.47.831",
      clipRule: "evenodd"
    })
  }));
};

export { LeafIcon };
